// keyvisual
import Unit1 from './unit1.json';
import Unit2 from './unit2.json';
import Unit3 from './unit3.json';
import Reception from './reception.json';
import Background from './background.json';
import Bench from './bench.json';
import Xray from './xray.json';
import XrayMonitor from './xray-monitor.json';
import Dodai from './dodai.json';
import Karte from './karte-view.json';
import Schedule from './schedule-view.json';
import Billing from './billing-view.json';

// other
import Arrow from './arrow.json';
import ArrowRight from './arrow-right.json';

export const Animes = {
  unit1: Unit1,
  unit2: Unit2,
  unit3: Unit3,
  reception: Reception,
  background: Background,
  bench: Bench,
  xray: Xray,
  'xray-monitor': XrayMonitor,
  dodai: Dodai,
  karte: Karte,
  schedule: Schedule,
  billing: Billing,
  arrow: Arrow,
  'arrow-right': ArrowRight,
} as const;
